import { useWSModal, useWSModalCustom } from "@wingspanhq/fe-component-library";
import { W9Consent } from "./index";

export const useModalShareTaxInformationWithPayers = () =>
  useWSModalCustom(W9Consent);
